














































import { Vue, Component } from 'vue-property-decorator'
import HeaderBar from '@/components/header-bar/index.vue'
import MTab from '@/components/m-tab/Index.vue'
import { getHelpList } from '@/services/help'
import { jumpPage } from '@/utils/mUtil'
interface ITab {
  id: number
  text: string
}
interface IQues {
  id: number
  question: string
}
@Component({
  components: {
    HeaderBar,
    MTab,
  },
})
export default class HelpCenter extends Vue {
  pageNo: number = 1
  pageSize: number = 10
  selectedId: number = 1
  listData: Array<IQues> = []
  isLoadingList: boolean = true
  noMore: boolean = false
  scrollEle!: HTMLElement | null
  mainEle!: HTMLElement | null
  showBigTitle: boolean = true
  topDistance: number = 378
  originTop: number = 100
  originHeight: number = 0
  vh: number = 0
  tabs: Array<ITab> = [
    {
      id: 1,
      text: '创作相关',
    },
    {
      id: 2,
      text: '收益相关',
    },
    {
      id: 3,
      text: '其他问题',
    },
  ]
  get IsEmpty() {
    return !this.isLoadingList && this.listData.length === 0
  }
  created() {
    this.getListData()
  }
  mounted() {
    this.scrollEle = document.getElementById('scrollContainer')
    this.mainEle = document.getElementById('main')
    this.scrollEle &&
      this.scrollEle.addEventListener('scroll', this.onPositionChange, false)
    this.calcVH()
    this.addClass() // 解决滚动穿透bug
  }
  addClass() {
    const app = document.getElementById('app')
    document.getElementsByTagName('html')[0].classList.add('z-no-scroll')
    document.getElementsByTagName('body')[0].classList.add('z-no-scroll')
    app && app.classList.add('z-no-scroll')
  }
  removeClass() {
    const app = document.getElementById('app')
    document.getElementsByTagName('html')[0].classList.remove('z-no-scroll')
    document.getElementsByTagName('body')[0].classList.remove('z-no-scroll')
    app && app.classList.remove('z-no-scroll')
  }
  calcVH() {
    const routerView = document.querySelector('.router-view')
    this.vh =
      document.compatMode == 'CSS1Compat'
        ? document.documentElement.clientHeight
        : (routerView as HTMLElement).offsetHeight // 浏览器视口的高度
  }
  calcIsBottom() {
    const routerView = document.querySelector('.router-view')
    const top = document.documentElement.scrollTop || document.body.scrollTop
    const height = Math.max(
      (routerView as HTMLElement).offsetHeight,
      document.documentElement.scrollHeight
    ) // 文档的总高度
    // 滚动到底部
    return top + this.vh >= height - 100
  }
  beforeDestroy() {
    this.removeClass()
  }
  destroyed() {
    this.scrollEle &&
      this.scrollEle.removeEventListener('scroll', this.onPositionChange, false)
  }
  onPositionChange() {
    if (this.scrollEle && this.mainEle) {
      let top: number = this.scrollEle.scrollTop
      this.showBigTitle = top < 62
    }
    if (!this.noMore && this.calcIsBottom()) {
      this.pageNo = this.pageNo + 1
      this.getListData()
    }
  }
  async getListData() {
    this.isLoadingList = true
    const res = await getHelpList({
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      questiontype: this.selectedId,
    })
    if (res.code === 200) {
      this.listData = this.listData.concat(res.data)
      this.noMore = res.page.pageCount <= this.pageNo
    }
    this.isLoadingList = false
  }
  handleTabChange(id: number) {
    this.selectedId = id
    this.isLoadingList = true
    this.listData = []
    this.pageNo = 1
    this.getListData()
  }
  handleClickQues(ques: IQues) {
    localStorage.setItem('QC_ques', JSON.stringify(ques))
    jumpPage(`${location.origin}/quesDetail?isHideNavBar=1&isFullScreen=1`)
  }
}
